var _a;
import Long from 'long';
import { ConverterType } from '../domain';
export var duration = (_a = {
        types: ['google.protobuf.Duration']
    },
    _a[ConverterType.TO_JSON] = {
        transfrom: function (_a) {
            var _b = _a.seconds, seconds = _b === void 0 ? 0 : _b, _c = _a.nanos, nanos = _c === void 0 ? 0 : _c;
            var nanosPortion = '';
            if (nanos !== 0) {
                nanosPortion = "." + nanos.toString().padStart(9, '0');
            }
            return "" + seconds + nanosPortion + "s";
        },
    },
    _a[ConverterType.FROM_JSON] = {
        transfrom: function (val) {
            var _a = val.substring(0, val.length - 1).split('.'), seconds = _a[0], nanos = _a[1];
            return {
                seconds: Long.fromString(seconds),
                nanos: nanosForString(nanos),
            };
        },
    },
    _a);
function nanosForString(nanos) {
    var res = 0;
    if (nanos !== undefined) {
        var precision = 3 - nanos.length / 3;
        res = parseInt(nanos, 10) * Math.pow(1000, precision);
    }
    return res;
}
//# sourceMappingURL=duration.js.map